import React from 'react';
import { cx } from '../cx';
import { Search } from './Search';
import { Button } from './Button';

// D-09 §15.13 — Search Combo (검색 input + "검색" 버튼 조합, Figma 2615-1117)
// 기존 Search(아이콘·클리어 내장)와 .btn-primary 를 flex(.search-combo)로 조합한다.
// 검색 트리거는 버튼 클릭·Enter 공통(onSearch). size 는 Search·Button 에 함께 전달돼 높이가 같이 변한다.
// 'width' 는 노출하지 않는다 — 조합(.search-combo)이 폭을 소유하므로 Search 의 width prop 이
// 적용되지 않는다(D-09 §15.13). 외부 폭 조절은 className 으로 한다.
export interface SearchComboProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'value' | 'size' | 'width'> {
  value: string;
  onChange: (value: string) => void;
  onSearch?: (value: string) => void; // 버튼 클릭 · Enter 공통
  onClear?: () => void;
  error?: string;
  size?: 'sm' | 'md' | 'lg';
  searchLabel?: string; // 기본 '검색'
  className?: string;
}

export function SearchCombo({
  value,
  onChange,
  onSearch,
  onClear,
  error,
  size = 'md',
  searchLabel = '검색',
  className = '',
  ...props
}: SearchComboProps) {
  return (
    <div className={cx('search-combo', className)}>
      {/* width="fill": 조합이 폭을 소유한다 — .search-combo .search{flex:1} 와 동일 결과를 명시 */}
      <Search
        value={value}
        onChange={onChange}
        onClear={onClear}
        error={error}
        size={size}
        width="fill"
        onKeyDown={(e) => {
          if (e.key === 'Enter') onSearch?.(value);
        }}
        {...props}
      />
      <Button type="button" variant="primary" size={size} onClick={() => onSearch?.(value)}>
        {searchLabel}
      </Button>
    </div>
  );
}
